import React from 'react'
import { IconsProps } from 'msp-integrations'

const WishlistAddIcon = (props: IconsProps) => {
  return (
    <svg
      width='27'
      height='23'
      viewBox='-1 -1 27 23'
      {...props}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d="M22.35 8.013c.075-.586.126-1.174.123-1.77v-.167c0-3.35-2.72-6.076-6.062-6.076a6.072 6.072 0 0 0-5.176 2.907A6.068 6.068 0 0 0 6.063 0C2.719 0 0 2.727 0 6.125v.118c-.005 3.811 1.521 7.317 4.663 10.72 2.25 2.433 5.391 5.052 6.578 5.052h.01c1.166 0 4.308-2.619 6.557-5.051.264-.286.501-.575.744-.863.66.38 1.416.614 2.23.614a4.503 4.503 0 0 0 4.499-4.498c.003-1.931-1.222-3.565-2.932-4.204Zm-5.13 8.403c-2.573 2.783-5.345 4.793-5.998 4.793h-.005c-.618 0-3.388-2.01-5.963-4.793-3-3.247-4.456-6.575-4.45-10.173v-.167C.804 3.17 3.164.804 6.063.804a5.268 5.268 0 0 1 4.806 3.13l.366.829.367-.828A5.268 5.268 0 0 1 16.408.804c2.902 0 5.259 2.365 5.259 5.272v.167c0 .524-.04 1.041-.1 1.554a4.454 4.454 0 0 0-.787-.078 4.503 4.503 0 0 0-4.499 4.498c0 1.375.634 2.592 1.608 3.42-.216.259-.43.517-.67.78Zm3.565-.507c-.623 0-1.2-.17-1.715-.442a3.753 3.753 0 0 1-.666-.45c-.796-.68-1.314-1.675-1.314-2.803a3.7 3.7 0 0 1 3.695-3.694c.227 0 .448.027.663.067.27.049.532.121.78.226a3.701 3.701 0 0 1 2.252 3.401 3.699 3.699 0 0 1-3.695 3.695Z" /><path d="M21.187 9.733h-.804v2.08h-2.079v.803h2.08v2.08h.803v-2.08h2.08v-.803h-2.08v-2.08Z" />
    </svg>
  )
}

export default WishlistAddIcon
